import { useRouter } from 'next/router';
import { useMemo } from 'react';
export function useOfferDetection() {
  var offers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var promotions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var router = useRouter();
  return useMemo(() => {
    var _ref, _matchedOffer$cellCod, _ref2, _matchedOffer$corpId, _ref3, _matchedOffer$promoCo;
    var _router$query = router.query,
      CELLCODES = _router$query.CELLCODES,
      CORPID = _router$query.CORPID,
      PROMOID = _router$query.PROMOID;
    var cellCodesFromUrl = CELLCODES;
    var corpIdFromUrl = CORPID;
    var promoIdFromUrl = PROMOID;
    var currentPage = getCurrentPagePath(router.asPath);
    var foundOffer = findOfferForPage(offers, currentPage, cellCodesFromUrl, corpIdFromUrl);
    var foundPromotion = findPromotionForPage(promotions, currentPage, promoIdFromUrl);
    var promotionAsUnifiedOffer = foundPromotion ? {
      maxRooms: foundPromotion.maxRooms,
      numberOfNights: foundPromotion.numberOfNights,
      cellCode: '',
      corpId: '',
      page: foundPromotion.page,
      ratePlanCode: '',
      promoCode: foundPromotion.promoCode,
      maxRoomsAmend: foundPromotion.maxRoomsAmend,
      enabled: foundPromotion.enabled
    } : null;
    var isActiveOffer = isOfferActive(foundOffer);
    var isActivePromotion = isPromotionActive(foundPromotion) && (foundPromotion === null || foundPromotion === void 0 ? void 0 : foundPromotion.enabled) === true;
    var matchedOffer = isActiveOffer ? foundOffer : isActivePromotion ? promotionAsUnifiedOffer : null;
    var hasActiveMatch = matchedOffer !== null;
    return {
      cellCodes: (_ref = (_matchedOffer$cellCod = matchedOffer === null || matchedOffer === void 0 ? void 0 : matchedOffer.cellCode) !== null && _matchedOffer$cellCod !== void 0 ? _matchedOffer$cellCod : cellCodesFromUrl) !== null && _ref !== void 0 ? _ref : null,
      corpId: (_ref2 = (_matchedOffer$corpId = matchedOffer === null || matchedOffer === void 0 ? void 0 : matchedOffer.corpId) !== null && _matchedOffer$corpId !== void 0 ? _matchedOffer$corpId : corpIdFromUrl) !== null && _ref2 !== void 0 ? _ref2 : null,
      promoId: (_ref3 = (_matchedOffer$promoCo = matchedOffer === null || matchedOffer === void 0 ? void 0 : matchedOffer.promoCode) !== null && _matchedOffer$promoCo !== void 0 ? _matchedOffer$promoCo : promoIdFromUrl) !== null && _ref3 !== void 0 ? _ref3 : null,
      matchedOffer,
      hasActiveMatch
    };
  }, [router.asPath, router.query, offers, promotions]);
}
function getCurrentPagePath(asPath) {
  var pathWithoutQuery = asPath.split('?')[0].split('#')[0];
  return pathWithoutQuery;
}
function isPageMatch(offerPage, currentPage) {
  if (!offerPage) {
    return false;
  }
  return currentPage.includes(offerPage);
}
function findOfferForPage(offers, currentPage, cellCodesFromUrl, corpIdFromUrl) {
  if (!offers || offers.length === 0) {
    return null;
  }
  var isOnOffersPage = currentPage.includes('/offers/') || currentPage.includes('/angebote/');
  var matchedOffer = offers.find(offer => isOnOffersPage && isPageMatch(offer.page, currentPage) || offer.cellCode && cellCodesFromUrl && offer.cellCode === cellCodesFromUrl || offer.corpId != null && corpIdFromUrl != null && +offer.corpId === +corpIdFromUrl);
  return matchedOffer || null;
}
function isPromotionLandingPage(currentPage) {
  var promoLandingPageRegex = /\/(gb\/en\/promotions|de\/de\/aktionen|en\/promotions|de\/aktionen|promotions|aktionen)\/([^/]+)\.html/;
  return promoLandingPageRegex.test(currentPage);
}
function getPromotionPageName(currentPage) {
  var promoLandingPageRegex = /\/(gb\/en\/promotions|de\/de\/aktionen|en\/promotions|de\/aktionen|promotions|aktionen)\/([^/]+)\.html/;
  var match = currentPage.match(promoLandingPageRegex);
  return match ? match[2] : null;
}
function findPromotionForPage(promotions, currentPage, promoIdFromUrl) {
  var _promotions$find;
  if (!promotions || promotions.length === 0) {
    return null;
  }
  var isOnPromoPage = isPromotionLandingPage(currentPage);
  var promoPageName = isOnPromoPage ? getPromotionPageName(currentPage) : null;
  return (_promotions$find = promotions.find(promotion => promotion.enabled && (isOnPromoPage && promoPageName && promotion.page === promoPageName || promotion.promoCode && promoIdFromUrl && promotion.promoCode === promoIdFromUrl))) !== null && _promotions$find !== void 0 ? _promotions$find : null;
}
export function isOfferActive(offer) {
  return offer !== undefined && offer !== null && Object.keys(offer).length > 0;
}
export function isPromotionActive(promotion) {
  return promotion != null && promotion.enabled && Object.keys(promotion).length > 0;
}